import { useEffect } from "react";
import { Grid2 as Grid, Typography } from "@mui/material";
import { FormRadio } from "../../../Shared/Form";
import { Dashboard, Layers, ViewDay } from "@mui/icons-material";
import all_sample from "../../../../assets/all_sample.png";
import home_sample from "../../../../assets/home_sample.png";
import explore_sample from "../../../../assets/explore_sample.png";
import { CreateCampaignViewModelType } from "../ViewModel";

type ObjectivePageType = {
    viewModel: CreateCampaignViewModelType;
    setNextStepDisabled: (v: boolean) => void;
}

const ObjectivePage = ({ viewModel, setNextStepDisabled }: ObjectivePageType) => {
    const { objective, setObjective, setTemplateId } = viewModel;

    function handleObjectiveChange(value: number) {
        setObjective(value);
        setTemplateId(-1);
    }

    useEffect(() => {
        setNextStepDisabled(false);
    }, [setNextStepDisabled]);

    return (
        <div style={{ paddingTop: 5, paddingBottom: 5 }}>
            <Typography variant="h6" pt={1} pb={2}>What is your objective?</Typography>
            <div style={{ display: "flex", gap: 10 }}>
                <div style={{ position: 'relative', minWidth: 250, minHeight: 510 }}>
                    <img
                        src={all_sample}
                        width="250px"
                        style={{
                            opacity: objective === 0 ? 1 : 0,
                            transition: "all 0.3s ease-in-out",
                            position: "absolute"
                        }}
                        alt="all-page-preview"
                    />
                    <img
                        src={home_sample}
                        width="250px"
                        style={{
                            opacity: objective === 1 ? 1 : 0,
                            transition: "all 0.3s ease-in-out",
                            position: "absolute"
                        }}
                        alt="home-page-preview"
                    />
                    <img
                        src={explore_sample}
                        width="250px"
                        style={{
                            opacity: objective === 2 ? 1 : 0,
                            transition: "all 0.3s ease-in-out",
                            position: "absolute"
                        }}
                        alt="explore-page-preview"
                    />
                </div>
                <Grid container flexDirection="column" width={"100%"} spacing={4}>
                    <FormRadio
                        selected={objective}
                        setSelected={handleObjectiveChange}
                        value={1}
                        title="Home Page"
                        caption={"Display the ad as users scroll through their home feed.\nClicking the ad directs users to your website."}
                        img={ViewDay}
                        isRow={false}
                        size={12}
                    />
                    <FormRadio
                        selected={objective}
                        setSelected={handleObjectiveChange}
                        value={2}
                        title="Explore Page"
                        caption={"Display the ad as users browse new content.\nClicking the ad lets users view its details and choose to visit your website."}
                        img={Dashboard}
                        isRow={false}
                        size={12}
                    />
                    <FormRadio
                        selected={objective}
                        setSelected={handleObjectiveChange}
                        value={0}
                        title="All Pages"
                        caption={"Display the ad on all pages where ads appear."}
                        img={Layers}
                        isRow={false}
                        size={12}
                    />
                </Grid>
            </div>
        </div>
    )
}

export default ObjectivePage;
